import { render, staticRenderFns } from "./rating-secondary.vue?vue&type=template&id=6c0e5b02&scoped=true"
import script from "./rating-secondary.vue?vue&type=script&lang=js"
export * from "./rating-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e5b02",
  null
  
)

export default component.exports